const routes = {
    getAccounts: 'closing-period/accounts',
    getPeriods: 'closing-period/recent',
    createPeriod: 'closing-period/create',
    closePeriod: 'closing-period/closed',
    getAllClosing: 'closing-period',
    updateClosingPeriod: 'closing-period/update',
  };
  
  export default routes